/*
 * @Author: your name
 * @Date: 2020-03-03 16:35:58
 * @LastEditTime: 2022-06-09 21:15:29
 * @LastEditors: haima haima@yaomaitong.cn
 * @Description: In User Settings Edit
 * @FilePath: /static-kshdoctor/src/store/modules/user.js
 */
import * as UserService from '@/service/UserService'
import * as SystemService from '@/service/SystemService'
import * as types from '../mutation-types'
import mutation from '../mutation'
import { objFilter } from '@/utils/util'
import {getToken} from '@/utils/storage'
const state = {
	doctorInfo: {},
	representInfo: {},
	userStatus: '', //用户认证状态
	userAccountInfo: {

	},
	speakerInfo: {}, //讲者信息
	pageTitle: '',
	orderList: [],
	userType: '',
	departmentList: [],
	userMessageList: [], //消息中心列表
	imUserSig: '', //im 登陆sig
	showPageorientation: false, // false 竖屏  true 横屏
	imName: '', //im登陆名
	systemTimCode: 'C2Cquxiaohua', //系统消息单聊ID
	idCardReviewInfo: {}, //人脸识别的身份证信息
	modifyRecordDetail: {}, //代表修改医生信息详情
	pharmacyDetail: {}, //药店信息
	pharmacyPreviewDetail: {}, //药店修改详情信息
	showUserSpendToast: false,
	pharmacyTypeList: [
		{ label: '连锁药店', id: 212 },
		{ label: '个体药店', id: 211 },
	],
	provinceList: [],
	cityMap: [],
}
const getters = {
  doctorInfo: () => {return state.doctorInfo || {}},
	representInfo:()=>state.representInfo,
	giftCount:()=>state.giftCount,
	pageTitle:()=>state.pageTitle,
	orderList:()=>state.orderList,
	userStatus:()=>state?.doctorInfo?.certify,
	userAccountInfo: ()=> state.userAccountInfo,
	token: () => state.token,
	speakerInfo:()=>state.speakerInfo,
	departmentList:()=>state.departmentList,
	imUserSig:()=>state.imUserSig,
	imName:()=>state.imName,
	systemTimCode:()=>state.systemTimCode,
	userType: () => {
		let type = Number(getToken().split('_')[0])
		switch (type) {
			case 1:
				return 'doctor'
			case 2:
				return 'represent'
			case 7:
				return 'thirdUser'
			default:
				return 'doctor'
		}
	},
	idCardReviewInfo:()=>state.idCardReviewInfo,
	modifyRecordDetail:()=>state.modifyRecordDetail,
	showPageorientation: ()=> state.showPageorientation,
	pharmacyDetail:()=>state.pharmacyDetail,
	pharmacyPreviewDetail:()=>state.pharmacyPreviewDetail,
	pharmacyTypeList:()=>state.pharmacyTypeList,
	showUserSpendToast: () => state.showUserSpendToast,
	cityMap: () => state.cityMap,
	provinceList: () => state.provinceList,
}
const mutations = {
	[types.SET_USER_SPEND_VALID_STATUS] (state, status) {
		state.showUserSpendToast = status
	},
	[types.SET_PAGE_ORIENTATION] (state, status) {
		state.showPageorientation = status
	},
	[types.GET_IM_USER_SIG](state,data){
		state.imName = data.imId
		state.imUserSig = data.userSig
	},
	[types.GET_SPEAKER_INFO](state,res){
		state.speakerInfo = res
	},
	[types.GET_PHARMACY_DETAIL](state,res){
		state.pharmacyDetail = res.data
	},
	[types.UPDATE_SPEAKER_INFO] (state, res) {
		let detail = state.speakerInfo.detail || {}
		state.pharmacyDetail.detail = {...detail, status: 0}
	},
	[types.UPDATE_PHARMACY_INFO] (state, res) {
		let detail = state.speakerInfo.detail || {}
		state.speakerInfo.detail = {...detail, status: 0}
	},
	[types.GET_DOCTOR_INFO](state, res) {
		state.doctorInfo = res
	},
	[types.SET_ID_CARD_INFO](state,{data}){
		state.idCardReviewInfo = data
	},
	[types.SET_MODIFY_RECORD_DETAIL](state,{data}){
		state.modifyRecordDetail = data
	},
	[types.SET_MODIFY_PHARMACY_DETAIL](state,data){
		state.pharmacyPreviewDetail = data
	},
	[types.HANDLE_RECORD_STATE](state,val){
		state.modifyRecordDetail = {...state.modifyRecordDetail,auditResult:val}
	},
	[types.HANDLE_PHARMACY_RECORD_STATE](state,val){
		state.pharmacyPreviewDetail = {...state.pharmacyPreviewDetail,auditResult:val}
	},
	[types.GET_USER_ACCOUNT_INFO] (state, obj) {
		state.userAccountInfo = obj
	},
	//地图
	[types.INIT_AREA_MAP](state, res) {
		let provinceList = []
		let cityMap = {}
		res.map(item => {
			provinceList.push({
				id: item.provinceId,
				label: item.provinceName
			})
			let cityList = item.cities.map(city => {
				return {
					id: city.cityId,
					label: city.cityName
				}
			})
			cityMap[item.provinceId] = cityList
		})
		state.provinceList = provinceList
		state.cityMap = cityMap
	},
	...mutation
}

const actions = {
	onValidUserMobile ({commit, state}, mobile) {
		return UserService.onValidUserMobile(mobile).then(res=>{
			return Promise.resolve(res.data)
		}, rea=>{
			return Promise.reject(rea)
		})
	},
	onApplyUserUnseal ({commit, state}, req) {
		return UserService.onApplyUserUnseal(req).then(res=>{
			return Promise.resolve(res)
		}, rea=>{
			return Promise.reject(rea)
		})
	},
	onUserLogoff ({commit, state}, req) {
		return UserService.onUserLogoff(req).then(res=>{
			return Promise.resolve(res.data)
		}, rea=>{
			return Promise.reject(rea)
		})
	},
	getVerifyCode ({commit, state}, req) {
		return UserService.getVerifyCode(req).then(res=>{
			return Promise.resolve(res)
		}, rea=>{
			return Promise.reject(rea)
		})
	},
	setVerifyCodeUpdateMobile(_, { oldMobile, oldCode, newMobile, newCode }) {
		return UserService.setVerifyCodeUpdateMobile(oldMobile, oldCode, newMobile, newCode).then(
			res => {
				return Promise.resolve(res);
			},
			rea => {
				return Promise.reject(rea);
			}
		);
	},
	getUserFaceConfig(_,tmpId) {
		return UserService.getUserFaceConfig(tmpId).then(
			res => {
				return Promise.resolve(res.data);
			},
			rea => {
				return Promise.reject(rea);
			}
		);
	},
	setFaceAuthUpdateMobile(_, reqObj) {
		return UserService.setFaceAuthUpdateMobile(reqObj).then(
			res => {
				return Promise.resolve(res);
			},
			rea => {
				return Promise.reject(rea);
			}
		);
	},
	setUnLoginFaceAuthUpdateMobile(_, reqObj) {
		return UserService.setUnLoginFaceAuthUpdateMobile(reqObj).then(
			res => {
				return Promise.resolve(res);
			},
			rea => {
				return Promise.reject(rea);
			}
		);
	},
	getUserAccountInfo ({commit, state}) {
		return UserService.getUserAccountInfo().then(res=>{
			commit(types.GET_USER_ACCOUNT_INFO, res.data)
			return Promise.resolve(res)
		}, rea=>{
			return Promise.reject(rea)
		})
	},
	onRecallUserGift ({commit, state}, req) {
		return UserService.onRecallUserGift(req).then(res=>{
			return Promise.resolve(res)
		}, rea=>{
			return Promise.reject(rea)
		})
	},
	getUserRecallGiftList({commit, state}, req) {
		return UserService.getUserRecallGiftList(req).then(res=>{
			return Promise.resolve(res)
		}, rea=>{
			return Promise.reject(rea)
		})
	},
	getUserSupportDetail ({commit, state}) {
		return UserService.getUserSupportDetail().then(res=>{
			return Promise.resolve(res)
		}, rea=>{
			return Promise.reject(rea)
		})
	},
	getAuthRejectReason({ commit, state }, auditType) {
		return UserService.getAuthRejectReason(auditType).then(
			res => {
				return Promise.resolve(res)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	onRealNameValidCount({ commit, state }) {
		return UserService.realNameAuthCount().then(
			res => {
				return Promise.resolve(res)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	hasBindRep({ commit, state }) {
		return UserService.hasBindRep().then(
			res => {
				return Promise.resolve(res.data)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	setDoctorUserAuth({ commit, state }, req) {
		return UserService.uploadAuth(req).then(
			res => {
				commit(types.UPDATE_DOCTOR_INFO, { certify: 'examining' })
				return Promise.resolve(res)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	onAgreeNotify({ commit, state }, notifyType = 6) {
		return UserService.onAgreeNotify(notifyType).then(
			res => {
				return Promise.resolve(res)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	getUserNotify({ commit, state }, notifyType = [6]) {
		return UserService.getUserNotify(notifyType).then(
			res => {
				return Promise.resolve(res)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	getRepresentInfo({ commit, state }, representId) {
		return UserService.getRepresentInfo(representId).then(
			res => {
				commit(types.SET_REPRESENT_INFO, res.data)
				return Promise.resolve(res.data)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	onSetPageOrientation({ commit, state }, status) {
		commit(types.SET_PAGE_ORIENTATION, status)
	},
	getImUserInfo({ commit, state }) {
		return UserService.getUserImSig().then(
			res => {
				commit(types.GET_IM_USER_SIG, res.data)
				return Promise.resolve(res.data)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	onUpdateSpeakerInfo({ commit, state }, data) {
		return UserService.onSubmitSpeaker(data).then(
			res => {
				commit(types.UPDATE_SPEAKER_INFO, res.data)
				return Promise.resolve(res.data)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	getDoctorInfo({ commit, state }) {
		let token = getToken() || ''
		let isRep = token.split('_')[0] == 2
		let req = isRep ? UserService.getRepresentUserDetail : UserService.getDoctorInfo
		return req().then(
			res => {
				const { data } = res
				if (isRep) {
					// 代表等级为4级
					commit(types.GET_DOCTOR_INFO, {
						...data,
						kitCount: data.giftCount,
						disposableGiftCount: data.giftCount,
						doctorCreditRating: 4,
						certify: 'has_certify'
					})
				} else {
					commit(types.GET_DOCTOR_INFO, {...data})
					// 新埋点，设置用户相关信息
					window.$analysysAgentSetProfile(
						objFilter({
              doctor_id: data.id,
							hospital: data.hospital,
							department_first_id: data.departmentFirstId,
							department_second_id: data.departmentSecondId,
							title_name: data.jobTitle.title,
							doctor_name: data.name,
							hospital_province_id: data.hospitalProvinceId,
							hospital_city_id: data.hospitalCityId
						})
					)
				}
				return Promise.resolve(data)
			},
			rea => {
				return Promise.reject(rea)
			}
		).catch(error => {
      console.log(error)
    })
	},
	getUvipInfo({ commit, state }) {
		return UserService.getUvipInfo().then(
			res => {
				commit(types.GET_DOCTOR_INFO, res.data)
				return Promise.resolve(res)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	setPageTitle({ commit, state }, title) {
		return commit(types.SET_PAGE_TITLE, title)
	},
	getFaceAuthResult({ commit, state }, req) {
		commit(types.REQUEST_DOING)
		return UserService.getFaceAuthResult(req).then(
			res => {
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res.data)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	getFaceValidResult({ commit }, req) {
		commit(types.REQUEST_DOING)
		return UserService.getFaceValidResult(req).then(
			res => {
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res.data)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	uploadIdCardImage({ commit, state }, data) {
		commit(types.REQUEST_DOING)
		return UserService.uploadIdCardImage(data).then(
			res => {
				commit(types.UPDATE_DOCTOR_INFO, { realNameAuth: 3 })
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	getFaceAuthUrl({ commit, state }, req) {
		commit(types.REQUEST_DOING)
		return UserService.getFaceAuthUrl(req).then(
			res => {
				commit(types.REQUEST_CLOSE)
				commit(types.UPDATE_DOCTOR_INFO, { realNameAuth: res?.data?.realNameAuth })
				return Promise.resolve(res.data)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	getFaceValidUrl({ commit, state }, req) {
		commit(types.REQUEST_DOING)
		return UserService.getFaceValidUrl(req).then(
			res => {
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res.data)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	getIdCardInfo({ commit, state }) {
		commit(types.REQUEST_DOING)
		return UserService.getIdCardInfo().then(
			res => {
				commit(types.REQUEST_CLOSE)
				commit(types.SET_ID_CARD_INFO, { data: res.data })
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	uploadCommonImage({ commit, state }, { file, bucketType }) {
		commit(types.REQUEST_DOING)
		return UserService.onUploadImage(file, bucketType).then(
			res => {
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	onOcrLicense({ commit, state }, { file }) {
		commit(types.REQUEST_DOING)
		return UserService.onOcrLicense(file).then(
			res => {
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	getDoctorCertifyImage({ commit, state }) {
		commit(types.REQUEST_DOING)
		return UserService.getDoctorCertifyImage().then(
			res => {
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	getModifyRecordDetail({ commit }, recordId) {
		commit(types.REQUEST_DOING)
		return UserService.getModifyRecordDetail(recordId).then(
			res => {
				commit(types.REQUEST_CLOSE)
				commit(types.SET_MODIFY_RECORD_DETAIL, { data: res.data })
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	getModifyPharmacyDetail({ commit }, data) {
		commit(types.REQUEST_DOING)
		return UserService.getModifyPharmacyDetail(data).then(
			res => {
				commit(types.REQUEST_CLOSE)
				commit(types.SET_MODIFY_PHARMACY_DETAIL, res.data)
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	confirmModifyRecord({ commit }, data) {
		commit(types.REQUEST_DOING)
		return UserService.confirmModifyRecord(data).then(
			res => {
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	handleRecordState({ commit }, val) {
		commit(types.HANDLE_RECORD_STATE, val)
	},
	handlePharmacyRecordState({ commit }, val) {
		commit(types.HANDLE_PHARMACY_RECORD_STATE, val)
	},
	submitPharmacyImage({ commit }, data) {
		commit(types.REQUEST_DOING)
		return UserService.submitPharmacyImage(data).then(
			res => {
				commit(types.UPDATE_DOCTOR_INFO, { hospitalStatus: 0, identity: 2 })
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	getPharmacyDetail({ commit, state }) {
		return UserService.getPharmacyDetail().then(
			res => {
				commit(types.GET_PHARMACY_DETAIL, res)
				return Promise.resolve(res)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	onUpdatePharmacyInfo({ commit, state }, data) {
		commit(types.REQUEST_DOING)
		return UserService.onUpdatePharmacyInfo(data).then(
			res => {
				commit(types.REQUEST_CLOSE)
				commit(types.UPDATE_DOCTOR_INFO, { hospitalStatus: 0, identity: 2 })
				commit(types.UPDATE_PHARMACY_INFO, res)
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	onUpdateUserInfo({ commit, state }, data) {
		commit(types.REQUEST_DOING)
		return UserService.updateUserInfo(data).then(
			res => {
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	getSystemMessageList({ commit, state }, data) {
		commit(types.REQUEST_DOING)
		return SystemService.getSystemMessageList(data).then(
			res => {
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	getAppDownLoadUrl({ commit, state }, data) {
		return SystemService.getAppDownLoadUrl(data).then(
			res => {
				return Promise.resolve(res)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	confirmPharmacyUserRecord({ commit, state }, data) {
		commit(types.REQUEST_DOING)
		return UserService.confirmPharmacyUserRecord(data).then(
			res => {
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	confirmPharmacyRecord({ commit, state }, data) {
		commit(types.REQUEST_DOING)
		return UserService.confirmPharmacyRecord(data).then(
			res => {
				commit(types.REQUEST_CLOSE)
				return Promise.resolve(res)
			},
			rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			}
		)
	},
	// 药店认证
	changeRegisterType({ commit }, data) {
		return UserService.changeRegisterType(data).then(
			res => {
				return Promise.resolve(res)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},

	// 医院
	onSearchHospital({ commit }, data) {
		return UserService.onSearchHospital(data).then(
			res => {
				return Promise.resolve(res)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},

	// 医院科室
	onSearchDepartment({ commit }, data) {
		return UserService.onSearchDepartment(data).then(
			res => {
				return Promise.resolve(res)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	// 获取活动报名个人信息
	getWebSignUpUserInfo({ commit }, req) {
		return UserService.getWebSignUpUserInfo(req).then(
			res => {
				return Promise.resolve(res.data)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	// 活动报名
	onWebSignUp({ commit }, req) {
		return UserService.onWebSignUp(req).then(
			res => {
				return Promise.resolve(res)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	getWebSignUpDetail({ commit }, req) {
		return UserService.getWebSignUpDetail(req).then(
			res => {
				return Promise.resolve(res.data)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	renlijiaAutor({ commit }, req) {
		return UserService.renlijiaAutor(req).then(
			res => {
				return Promise.resolve(res.data)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	getSpeakerFailInfo({ commit, state }) {
		return UserService.getSpeakerFailInfo().then(
			res => {
				return Promise.resolve(res.data)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	reSubmitSpeakerInfo({ commit, state },req) {
		return UserService.reSubmitSpeakerInfo(req).then(
			res => {
				return Promise.resolve(res.data)
			},
			rea => {
				return Promise.reject(rea)
			}
		)
	},
	getCityInfo({ commit, state }) {
		return UserService.getCityInfo()
			.then(res => {
				commit(types.INIT_AREA_MAP, res.data)
			}, rea => {
				return Promise.reject(rea)
			})
	},
}

export default {
	state,
	getters,
	actions,
	mutations
}
